export const OK = "OK";
export const NO_FOOTAGE = "NO_FOOTAGE";
export const UNKNOWN = "UNKNOWN";
export const UNSPECIFIED_ERROR = "UNSPECIFIED_ERROR";

export const mapToDisplay = (status) => {
  if (status === OK) return "Ok";
  if (status === NO_FOOTAGE) return "No footage";
  if (status === UNKNOWN) return "Unknown";
  if (status === UNSPECIFIED_ERROR) return "Error";

  return status;
};
